import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createBlock(_component_v_progress_circular, _mergeProps({
    "model-value": _ctx.$attrs.value ? _ctx.$attrs.width : 75,
    color: _ctx.$attrs.color || (_ctx.$projectName === _ctx.$projectNames.MOSAP ? 'var(--pageContrastFont)' : 'var(--pageAccentBackground)'),
    size: _ctx.$attrs.size ? _ctx.$attrs.size : 70,
    width: _ctx.$attrs.width ? _ctx.$attrs.width : 7
  }, _ctx.$attrs, {
    class: ["base-loader", _ctx.classes]
  }), null, 16, ["model-value", "color", "size", "width", "class"]))
}